module.exports = __webpack_public_path__ + "static/media/broken-robot.d23c0145.png";